var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H2V20C2 21.105 2.895 22 4 22H18V20H4V6ZM20 2H8C6.895 2 6 2.895 6 4V16C6 17.105 6.895 18 8 18H20C21.105 18 22 17.105 22 16V4C22 2.895 21.105 2 20 2ZM19 11H15V15H13V11H9V9H13V5H15V9H19V11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationPlus);
export default __webpack_public_path__ + "static/media/organizationPlus.7bce4acd5c9462b30902e1af3e73c435.svg";
export { ForwardRef as ReactComponent };